import { Component, OnInit, Input } from '@angular/core';
import { FileProduct, InfoExt } from 'src/app/_models';
import { CatalogService, UtilsService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-extended-info-modal',
  templateUrl: './product-extended-info-modal.component.html',
  styleUrls: ['./product-extended-info-modal.component.css']
})
export class ProductExtendedInfoModalComponent implements OnInit {


  public fileProduct : FileProduct;
  public extendedInfo : InfoExt;
  
  constructor(
    public utils : UtilsService,
    public catalog : CatalogService,
    private translate : TranslateService,
    private spinner : NgxSpinnerService
  ) { }

  ngOnInit() {
  }


  
  loadData() : any{
    
    setTimeout(() => {
      this.spinner.show('extendedInfoSpinner');        
    }, environment.READY_TIMEOUT);

    this.extendedInfo = null;
    
    if (this.fileProduct.filedetails.extended){
      this.catalog.getProductExtendedInfo(this.fileProduct.product.item_id,this.fileProduct.filedetails.extended, this.translate.currentLang).subscribe( result =>{
        this.extendedInfo = result;
        setTimeout(() => {
          this.spinner.hide('extendedInfoSpinner');  
        }, environment.READY_TIMEOUT);       
      }, error =>{
        setTimeout(() => {
          this.spinner.hide('extendedInfoSpinner');  
        }, environment.READY_TIMEOUT);

      });
    }
  }

}
